import { BodyText } from '@/components/BodyText';
import { TitleText } from '@/components/TitleText';
import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import { StyledServiceAccountAccordion } from './ServiceAccountCard';

export const ServiceAccountNoPermissionState = () => {
  return (
    <StyledServiceAccountAccordion defaultExpanded={false}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <TitleText>My Service Account</TitleText>
      </AccordionSummary>
      <AccordionDetails>
        <BodyText color='text.secondary' sx={{ mb: 1 }}>
          Service accounts provide programmatic API access for automation and integrations.{' '}
        </BodyText>

        <BodyText color='text.secondary'>Contact your administrator if you need API access.</BodyText>
      </AccordionDetails>
    </StyledServiceAccountAccordion>
  );
};
